<template>
    <div class=long-comic-page>
        <LongComic :images="post.acf.images" :content="post.content.rendered" @close-popup="back" />
    </div>
</template>
<script>
import LongComic from '../components/LongComic';

export default {
    name : 'LongComicPage',
    props : {
        post    : Object,
    },
    data() {
        return {
            content : '',
        }
    },
    components : {
        LongComic,
    },
    methods : {
        back() {
            this.$router.push({ name : this.$route.meta.parent });
        }
    },
}
</script>